import {Component, inject, OnInit} from '@angular/core';
import {DecimalPipe, NgForOf, NgIf} from "@angular/common";
import {DataService} from "../services/data.service";
import moment from "moment/moment";
import {FormsModule} from "@angular/forms";
import {BaseChartDirective} from "ng2-charts";
import {ChartConfiguration} from "chart.js";
import {flag} from "../pipes/flag.pipe";

@Component({
    selector: 'app-kpi',
    imports: [DecimalPipe, NgIf, NgForOf, FormsModule, BaseChartDirective, flag],
    template: `
        <h2 class="fw-bold"><i class="fa-solid fa-gauge-high me-2"></i>KPIs</h2>

        <div class="card" *ngIf="stats">
            <div class="card-body">
                <div class="d-flex flex-wrap align-items-center gap-3">
                    <select class="form-control" style="width: 155px" [(ngModel)]="id_region" (ngModelChange)="loadData()">
                        <option value="" selected>Alle Regionen</option>
                        <option *ngFor="let region of regions" [value]="region.id">{{ region.name }}</option>
                    </select>

                    <select class="form-control" style="width: 155px" [(ngModel)]="id_store" (ngModelChange)="loadData()">
                        <option value="" selected>Alle Stores</option>
                        <option *ngFor="let store of stores" [value]="store.id">{{ store.name }}</option>
                    </select>

                    <div class="input-group" style="width: 170px">
                        <div class="input-group-prepend">
                            <button class="btn btn-outline-secondary" type="button" (click)="setYear(-1)">
                                <i class="fa-solid fa-arrow-left"></i>
                            </button>
                        </div>
                        <input type="number" class="form-control"
                               [(ngModel)]="year"
                               [max]="currentYear"
                               (ngModelChange)="loadData()"/>
                        <div class="input-group-append">
                            <button class="btn btn-outline-secondary" type="button" [disabled]="year == currentYear" (click)="setYear(1)">
                                <i class="fa-solid fa-arrow-right"></i>
                            </button>
                        </div>
                    </div>

                </div>

                <div class="row mt-3">
                    <div class="col-sm-3 mb-1">
                        <div class="card">
                            <div class="card-body">
                                <div class="text-muted">Umsatz</div>

                                <h3 class="fw-bold mt-2 mb-0">€ {{ stats.turnover | number: '1.0-0' }}</h3>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-3 mb-1">
                        <div class="card">
                            <div class="card-body">
                                <div class="text-muted">Franchisumsatz</div>

                                <h3 class="fw-bold mt-2 mb-0">€ {{ stats.franchise | number: '1.0-0' }}</h3>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-3 mb-1">
                        <div class="card">
                            <div class="card-body">
                                <div class="text-muted">Stores</div>

                                <h3 class="fw-bold mt-2 mb-0">{{ stats.stores | number: '1.0-0' }}</h3>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-3 mb-1">
                        <div class="card">
                            <div class="card-body">
                                <div class="text-muted">Durchschnittswarenkorb</div>

                                <h3 class="fw-bold mt-2 mb-0">€ {{ stats.average | number: '1.2-2' }}</h3>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mt-3">
                    <div class="col-sm-3 mb-1">
                        <div class="card">
                            <div class="card-body">
                                <div class="text-muted">Kunden</div>

                                <h3 class="fw-bold mt-2 mb-0">{{ stats.customers | number: '1.0-0' }}</h3>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-3 mb-1">
                        <div class="card">
                            <div class="card-body">
                                <div class="text-muted">Ø Umsatz / m² / Monat</div>

                                <h3 class="fw-bold mt-2 mb-0">€ {{ stats.turnover_area | number: '1.0-0' }}</h3>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-3 mb-1">
                        <div class="card">
                            <div class="card-body">
                                <div class="text-muted">Ø Umsatz / Tag</div>

                                <h3 class="fw-bold mt-2 mb-0">€ {{ stats.turnover_day | number: '1.0-0' }}</h3>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-3 mb-1">
                        <div class="card">
                            <div class="card-body">
                                <div class="text-muted">Mietquote</div>

                                <h3 class="fw-bold mt-2 mb-0">{{ stats.rent_turnover | number: '1.1-1' }}%</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <h3 class="text-muted mt-4 mb-2">Stores Entwicklung</h3>

        <canvas baseChart *ngIf="yearData?.length > 0"
                [data]="chart.data"
                [options]="chart.options"
                [type]="chart.type"
                class="mt-3">
        </canvas>

        <div class="table-responsive">
            <table *ngIf="yearData?.length > 0" class="table table-striped table-hover mt-3 mb-0 pointer">
                <thead>
                <tr>
                    <td style="width: 200px"></td>
                    <td class="text-end" *ngFor="let year of yearData">{{year.year}}</td>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>Umsatz (€)</td>
                    <td class="text-end" *ngFor="let year of yearData">{{ year.turnover | number: '1.0-0' }}</td>
                </tr>
                <tr>
                    <td>Kunden</td>
                    <td class="text-end" *ngFor="let year of yearData">{{ year.customers | number: '1.0-0' }}</td>
                </tr>
                <tr>
                    <td>Durchschnittswarenkorb (€)</td>
                    <td class="text-end" *ngFor="let year of yearData">{{ year.average | number: '1.2-2' }}</td>
                </tr>
                <tr>
                    <td>Ø Storegröße (m²)</td>
                    <td class="text-end" *ngFor="let year of yearData">{{ year.average_size | number: '1.0-0' }}</td>
                </tr>
                </tbody>
            </table>
        </div>

        <div class="row mt-3 row-cols-md-3 g-4" *ngIf="stats">
            <div class="col-sm-4 mb-1">
                <div class="card h-100">
                    <div class="card-body">
                        <h3 class="text-muted">Länder</h3>

                        <table class="table table-sm mt-2 mb-0">
                            <thead>
                            <tr>
                                <th>Land</th>
                                <th class="text-end"># Stores</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let country of stats.countries">
                                <td><span class="fi fi-{{ country.name | flag }} me-1"></span> {{ country.name }}</td>
                                <td class="text-end">{{ country.count }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="col-sm-4 mb-1">
                <div class="card h-100">
                    <div class="card-body">
                        <h3 class="text-muted">Lagen</h3>

                        <table class="table table-sm mt-2 mb-0">
                            <thead>
                            <tr>
                                <th>Lage</th>
                                <th class="text-end"># Stores</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let position of stats.positions">
                                <td>{{ position.name }}</td>
                                <td class="text-end">{{ position.count }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="col-sm-4 mb-1">
                <div class="card h-100">
                    <div class="card-body">
                        <h3 class="text-muted">Ø Storegröße</h3>

                        <h3 class="fw-bold mt-4 mb-4">{{ stats.average_size | number: '1.0-0' }} m²</h3>
                    </div>
                </div>
            </div>
        </div>
    `
})
export class KpiComponent implements OnInit {

    private dataService = inject(DataService);

    id_region = '';
    id_store = '';
    year = moment().year();
    currentYear = moment().year();

    regions!: any[];
    stores!: any[];
    stats: any;

    chart!: ChartConfiguration;

    yearData: any[] = [];

    ngOnInit(): void {
        this.loadData();

        this.dataService.request("Store/listForSelection").subscribe(response => {
            this.stores = response.stores;
        })

        this.dataService.request("Region/listForSelection").subscribe(response => {
            this.regions = response.regions;
        })
    }

    loadData() {
        this.dataService.request("Kpi/getData", {
            year: this.year,
            id_region: this.id_region,
            id_store: this.id_store,
        }).subscribe(response => {
            this.stats = response.stats;

            this.yearData = response.stats.year_data;

            this.chart = {
                type: 'bar',
                data: {
                    labels: this.yearData.map(d => d.year),
                    datasets: [
                        {
                            label: 'Geschlossen',
                            data: this.yearData.map(d => d.closed ? -d.closed : null),
                            backgroundColor: '#ef4444',
                            stack: 'stack0',
                            order: 1,
                        }, {
                            label: 'Eröffnet',
                            data: this.yearData.map(d => d.opened || null),
                            backgroundColor: '#22c55e',
                            stack: 'stack0',
                            order: 1,
                        },
                        {
                            label: 'Nicht in Betrieb',
                            data: this.yearData.map(d => d.inactive || null),
                            backgroundColor: '#9ca3af',
                            stack: 'stack0',
                            order: 1,
                        },
                        {
                            label: 'Gesamt',
                            data: this.yearData.map(d => d.total),
                            type: 'line',
                            borderColor: '#3b82f6',
                            backgroundColor: '#3b82f6',
                            borderWidth: 2,
                            fill: false,
                            tension: 0.1,
                            order: 0,
                        }
                    ]
                },
                options: {
                    responsive: true,
                    plugins: {
                        legend: {
                            display: true,
                            position: 'top'
                        },
                        datalabels: {
                            borderRadius: 5,
                            backgroundColor: (context: any) => context.dataset.data[context.dataIndex] === null ? null : '#000',
                            padding: {left: 4, top: 2, right: 4, bottom: 2},
                            color: '#fff',
                            font: {
                                size: 16,
                                weight: 'bold'
                            },
                            formatter: (value: any) => value === null ? '' : Math.abs(value)
                        }
                    },
                    scales: {
                        x: {
                            stacked: true
                        },
                        y: {
                            stacked: true,
                            beginAtZero: true
                        }
                    }
                }
            };
        });
    }

    setYear(number: number) {
        this.year += number;

        this.loadData();
    }
}
